import { CCard, CCardBody, CCardHeader } from '@coreui/react';
import { useState, useMemo } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import CIcon from '@coreui/icons-react';

import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify';
import SendPreviewViaMail from './SendPreviewViaMail';
import SavePreviewResults from './SavePreviewResults';

const md = new MarkdownIt({
  html: true,
  breaks: true,
  linkify: true,
  typographer: true
});

const defaultRender = md.renderer.rules.link_open || function(tokens, idx, options, env, self) {
  return self.renderToken(tokens, idx, options);
};

md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
  tokens[idx].attrPush(['target', '_blank']);
  tokens[idx].attrPush(['rel', 'noopener noreferrer']);
  return defaultRender(tokens, idx, options, env, self);
};


export default function ViewMarkdown({ title, markdown, isCsv = false, jobId }) {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 1500);
    };

    function wrapCsvInCodeBlock(markdown) {
        return markdown.replace(/(Data from .*?\.csv:)([\s\S]*?)(?=(Data from .*?\.csv:)|$)/g, (match, title, csvBlock) => {
            return `${title}\n\`\`\`csv\n${csvBlock.trim()}\n\`\`\`\n`;
        });
    }

    const sanitizedHtml = useMemo(() => {
         const processedMarkdown = isCsv ? wrapCsvInCodeBlock(markdown) : markdown;
         const rawHtml = md.render(processedMarkdown);
         DOMPurify.addHook('afterSanitizeAttributes', function (node) {
              if (node.tagName === 'A') {
                   node.setAttribute('target', '_blank');
                   node.setAttribute('rel', 'noopener noreferrer');
              }
         });
         const sanitized = DOMPurify.sanitize(rawHtml, {
              ADD_ATTR: ['target'],
         });
         return sanitized;
    }, [markdown, isCsv]);

    return (
        <div>
            <CCard>
                <CCardHeader className="d-flex justify-content-between align-items-center p-3">
                    {title && <h5 className="mb-0">{title}</h5>}
                    <div className="d-flex justify-content-end gap-2">
                        {jobId && (
                            <>
                                <SendPreviewViaMail jobId={jobId} />
                                <SavePreviewResults jobId={jobId} />
                            </>
                        )}

                        <CopyToClipboard text={markdown} onCopy={handleCopy}>
                            <div className="d-flex align-items-center pointer ml-auto">
                                 <CIcon icon="icon-copy" height={20} width={20} />
                                <span className="pt-1">{copied ? 'Copied' : 'Copy'}</span>
                            </div>
                        </CopyToClipboard>
                    </div>
                </CCardHeader>
                <CCardBody
                    className="view-markdown"
                    style={{
                        maxHeight: '750px',
                        overflowY: 'auto',
                        padding: '16px',
                    }}
                    dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
                >
                </CCardBody>
            </CCard>
        </div>
    );
}